import React from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'

import Stack from 'components/base/Stack'

const useStyles = createUseStyles({
  stack: {
    padding: [20, 70]
  }
})

function FullScreenModalFooter({
  children,
  className,
  variant,
  justify,
  ...props
}) {
  const classes = useStyles(props)

  return (
    <Stack
      justify={justify || 'flex-end'}
      className={classNames(classes.stack, className)}
    >
      {children}
    </Stack>
  )
}

export default FullScreenModalFooter
